import { Container } from '@tryhackme/thm-ui-components';
import { SEO } from 'src/common/components';
import { TwoFactorForm } from 'src/features/login/components/two-factor-form';
import { StyledTwoFactorPage } from './two-factor-page.styles';
export const TwoFactorPage = () => <section data-sentry-component="TwoFactorPage" data-sentry-source-file="two-factor-page.tsx">
    <SEO title="Login" description="TryHackMe is a free online platform for learning cyber security, using hands-on exercises and labs, all through your browser!" data-sentry-element="SEO" data-sentry-source-file="two-factor-page.tsx" />
    <Container data-sentry-element="Container" data-sentry-source-file="two-factor-page.tsx">
      <StyledTwoFactorPage data-sentry-element="StyledTwoFactorPage" data-sentry-source-file="two-factor-page.tsx">
        <TwoFactorForm data-sentry-element="TwoFactorForm" data-sentry-source-file="two-factor-page.tsx" />
      </StyledTwoFactorPage>
    </Container>
  </section>;